/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Address } from './address';

/**
 * Detailed company model serializer.
 */
export interface Company {
  readonly id: string;
  readonly name: string;
  readonly organization_number: string;
  readonly verified: boolean;
  readonly pitch: string;
  readonly tag_names: Array<string>;
  readonly logo: string;
  readonly address: Address;
  readonly website: string;
  readonly requires_logo: boolean;
}
